import { http, HttpResponse } from 'msw'

import { user } from '@/mocks/data/general/user'

import { api } from '@/utils/constants'

import { User } from '@/types/user'

export const me = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.user.PROFILE}`,
    () => {
        return HttpResponse.json<User[]>([user])
    },
)
